export const getArrayFromString = (value) => {
  if (Boolean(value) && typeof value === 'string') {
   return value.split(',');
  } else if (Boolean(value) && (value instanceof Array)) {
   return value;
  }
};

